import { render, staticRenderFns } from "./SeminarReserve.vue?vue&type=template&id=5940d1ce&scoped=true&"
import script from "./SeminarReserve.vue?vue&type=script&lang=js&"
export * from "./SeminarReserve.vue?vue&type=script&lang=js&"
import style0 from "./SeminarReserve.vue?vue&type=style&index=0&id=5940d1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5940d1ce",
  null
  
)

export default component.exports